import config from "@/config";
import i18n from "@/i18n";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    language: "en",
    sidebar: {
      minimized: false
    },
    pageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
    pageSizeModal: 10,
    pageSizeOptionsModal: [10, 20, 50, 100],
    dateRange: [
      moment()
        .startOf("month")
        .add(-1, 'months')
        .toDate(),
      moment()
        .endOf("day")
        .toDate()
    ],
    alert: true
  },
  mutations: {
    updateAlert(state, payload) {
      state.alert = payload;
    },
    updateLanguage(state, payload) {
      state.language = payload;
    },
    updateSidebarMinimized(state, payload) {
      state.sidebar.minimized = payload;
    },
    updatePageSize(state, payload) {
      state.pageSize = payload;
    },
    updatePageSizeModal(state, payload) {
      state.pageSizeModal = payload;
    },
    updateDateRange(state, payload) {
      state.dateRange = payload;
    }
  },
  actions: {
    setAlert(context, payload) {
      context.commit("updateAlert", payload);
    },
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    setSidebarMinimized(context, payload) {
      context.commit("updateSidebarMinimized", payload);
    },
    setPageSize(context, payload) {
      context.commit("updatePageSize", payload);
    },
    setPageSizeModal(context, payload) {
      context.commit("updatePageSizeModal", payload);
    },
    setDateRange(context, payload) {
      context.commit("updateDateRange", payload);
    }
  }
};
